import Vue from 'vue'
import Router from 'vue-router'
import baseRouter from './router-base'

import errorRouter from './router-error'
/*
  路由一般定义为三个部分：
    常规路由（router-base)：提供顶级的路由，通常为常用的路由、不需要按需加载的路由等等，保持最多20个路由，否则移入到模块路由
    异常路由（router-error）：提供各种异常，比如500, 404, 402(无权限）
    模块路由（router-modulename)：提供项目模块相关的路由，例如router-shops路由等等
*/

// V3.1.0版本里面新增功能：push和replace方法会返回一个promise, 你可能在控制台看到未捕获的异常
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/popadminweb',
  routes: [
    ...baseRouter,
    // ...errorRouter
  ]
})
